import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import {
  CustomResultOfPaginatedListOfUserWithPaginationDto,
  CustomResultOfSecurityTokenDto,
  GetEnumValuesDto,
  GetPrivateNumbersByUserIdDto,
  PaginatedListOfResellersWithPaginationByUserIdDto,
} from 'src/app/core/api/models';
import {
  ExcelService,
  OrganizationTransactionsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { QueryStringTypesEnum } from '../../../configs/query-string-types';
import { PaginatedListOfUserWithPaginationDto } from '../../../core/api/models/paginated-list-of-user-with-pagination-dto';
import { UserDto } from '../../../core/api/models/user-dto';
import { UserWithPaginationDto } from '../../../core/api/models/user-with-pagination-dto';
import { UsersService } from '../../../core/api/services/users.service';
import { FormPageConfig } from '../../../core/models/form-page-config.model';
import { DialogStatus } from '../../../core/services/dialog.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { PrivateNumberSendLimitFormComponent } from '../assign-numbers/private-number-send-limit/private-number-send-limit-form/private-number-send-limit-form.component';
import { ResellerOrganizationsComponent } from '../resellers/reseller-organizations/reseller-organizations.component';
import { AccountService } from './../../../core/api/services/account.service';
import { OrganizationsService } from './../../../core/api/services/organizations.service';
import { ResellersService } from './../../../core/api/services/resellers.service';
import { AuthTokenService } from './../../../core/services/authentication/auth-token.service';
import { AuthService } from './../../../core/services/authentication/auth.service';
import { CreateUsersExcelDialogComponent } from './create-users-excel/create-users-excel-dialog.component';
import { IncreaseUserCreditForm } from './increase-user-credit-form/increase-user-credit-form.component';
import { UpdatePasswordForm } from './update-password-form/update-password-form.component';
import { UserDocumentationFormModule } from './user-documentation-form/user-documentation-form.module';
import { UserFormModule } from './user-form/user-form.module';
import { UserPrivateNumbersListComponent } from './user-private-numbers/user-private-numbers.component';
import { UserTransactionsModule } from './user-transactions/user-transactions.module';
import { UsersImportFromXlsxFormModule } from './users-import-from-xlsx/users-import-from-xlsx.module';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  imports: [
    BaseIndexModule,
    UserFormModule,
    UserDocumentationFormModule,
    UserTransactionsModule,
    UsersImportFromXlsxFormModule,
    UserPrivateNumbersListComponent,
    ResellerOrganizationsComponent,
    PrivateNumberSendLimitFormComponent,
  ],
})
export class UsersComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties

  pageName = 'users';
  protected currentService = inject(UsersService);

  createGetApiMethodName: string =
    this.currentService.usersCreateUserInfoGet.name;
  deleteApiMethodName: string = this.currentService.usersDelete.name;
  auditApiMethodName: string = this.currentService.usersGetUsersAudit.name;

  modelWithPagination$: Observable<PaginatedListOfUserWithPaginationDto>;
  items$: Observable<Array<UserWithPaginationDto>>;
  formPageConfig: FormPageConfig<UserDto> = {};
  userOrganizationAuditPage: boolean = false;
  form: FormGroup;

  isShowUserDocumentation: boolean = false;
  isShowTransferPrivateNumber: boolean = false;
  isShowUserAuthentication: boolean = false;
  selectedUserId: number;
  selectedOrganizationId: any;
  selectedUserName: string;

  currentDate: string = null;
  isLoginByIdentity: boolean;
  isShowUsersImportFromXlsx: boolean = false;

  isShowResellerOrganizations: boolean = false;
  resellersOrganizationsWithPagination$: Observable<PaginatedListOfResellersWithPaginationByUserIdDto>;

  userTransactionsWithPagination$: Observable<any>;

  transferPrivateNumberFormPageConfig: FormPageConfig<UserDto> = {};
  DocumentationTypeEnumValues: GetEnumValuesDto[] = [];
  DocumentStatusEnumValues: GetEnumValuesDto[] = [];

  fontSize: AppFontSize = 'sm';
  isShowUserTransactions: boolean = false;
  isShowUserPrivateNumbersLists: boolean = false;
  isAdmin: boolean = false;
  userPrivateNumbersList: GetPrivateNumbersByUserIdDto[];
  userId: any;
  resellerUserId: number;
  //#endregion

  constructor(
    protected authService: AuthService,
    protected accountService: AccountService,
    protected organizationsService: OrganizationsService,
    protected organizationTransactionsService: OrganizationTransactionsService,

    protected excelFileService: ExcelService,
    protected resellersService: ResellersService,
    protected translate: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.getUserState();
      this.pageConfig.showAddBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  initForm() {
    this.form = new FormGroup({
      resellerId: new FormControl(''),
    });
  }
  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Transaction_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.isShowUserTransactions,
          selectedPropKey: [
            {
              keyName: this.componentProperties.selectedUserName,
              keyType: typeof this.selectedUserName,
            },
          ],
        });
      if (key == QueryStringTypesEnum.Organization_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.isShowResellerOrganizations,
          selectedPropKey: [
            {
              keyName: this.componentProperties.selectedUserId,
              keyType: typeof this.selectedUserId,
            },
          ],
        });
      if (key == QueryStringTypesEnum.PrivateNumbers_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey:
            this.componentProperties.isShowUserPrivateNumbersLists,
          selectedPropKey: [
            {
              keyName: this.componentProperties.userId,
              keyType: typeof this.userId,
            },
          ],
        });
      if (key == QueryStringTypesEnum.Documents_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.isShowUserDocumentation,
          selectedPropKey: [
            {
              keyName: this.componentProperties.selectedUserId,
              keyType: typeof this.selectedUserId,
            },
          ],
        });
      if (key == QueryStringTypesEnum.Update_key) this.onUpdate(value, false);
      if (key == QueryStringTypesEnum.TransferPrivateNumber_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.isShowTransferPrivateNumber,
          selectedPropKey: [
            {
              keyName: this.componentProperties.selectedUserId,
              keyType: typeof this.selectedUserId,
            },
          ],
        });
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('UserDocuments')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DocumentationTypeEnumValues = values));
    this.getEnumValuesApi('DocumentStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DocumentStatusEnumValues = values));
  }

  ngAfterViewInit(): void {
    try {
      if (this.authService.isAuthenticated()) this.isLoginByIdentity = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'userName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.firstName,
        name: 'firstName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.lastName,
        name: 'lastName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.mobile,
        name: 'mobile',
        hasSearch: true,
        wrap: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}nationalCode`,
        name: 'nationalCode',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.parentOrganization,
        name: 'parentOrganizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `common.domainName`,
        name: 'domainName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.credit,
        name: 'credit',
        needCurrency: true,
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      { title: 'common.roles', name: 'roles', noSorting: true, wrap: true },
      {
        title: this.localizer.activeSend,
        name: 'isActiveSend',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.lockOut,
        name: 'isLockout',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.authenticated,
        name: 'isAuthenticated',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: this.localizer.authenticatedMobile,
        name: 'isAuthenticatedMobile',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isAdmin`,
        name: 'Organization.AdminUserId',
        type: 'boolean',
        hasSearch: false,
        noSorting: true,
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfUserWithPaginationDto> {
    if (window.location.search.includes('key-')) {
      this.paginationModel.pageNumber = 1;
      this.paginationModel.pageSize = 30;
      this.comparisonObjects = [];
      this.sortObject = [{ columnName: 'created', sort: 1 }];
    }
    return this.currentService.usersGetUsersWithPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        resellerUserId: this.resellerUserId,
      },
    });
  }

  //Get ById
  baseGetByIdApi(id: any): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .usersUpdateUserInfoGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  accountImpersonateUserApi(userId: number) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.accountService
      .accountImpersonateUser({ body: { userId: userId.toString() } })
      .pipe(this.basePipeOperators())
      .subscribe((result: CustomResultOfSecurityTokenDto) => {
        try {
          if (result.isSucceed) {
            AuthTokenService.onSetTokens(
              result.data.accessToken,
              result.data.refreshToken,
              false
            );
            window.location.replace(window.location.origin);
          } else
            this.dialogService.openDialog({
              title: 'common.error',
              message: result.message,
              status: DialogStatus.error,
            });
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.systemManagement
          );
        }
      });
  }

  accountUnblockApi(userName: string) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.accountService
      .accountUnblock({ body: { userName: userName } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getOrganizationCreditApi(user: UserWithPaginationDto) {
    this.organizationsService
      .organizationsGetOrganizationCredit({
        organizationId: user.organizationId,
      })
      .pipe(this.basePipeOperators())
      .subscribe(
        (organizationCredit) => {
          let data = {
            userId: user.id,
            userCredit: user.credit,
            organizationCredit: organizationCredit?.data,
          };

          const modalResult = this.dialogService.openModal({
            component: IncreaseUserCreditForm,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe((res) => {
              if (res) {
                this.getTableData();
                this.cd.detectChanges();
              }
            });
        },
        (error) => {
          let errTitle = 'messages.htmlStatus.code403';
          let errMsg = this.translate.instant('messages.htmlStatus.code403Msg');
          this.openErrorDialog(errTitle, errMsg);
        }
      );
  }

  onUpdatePassword(userId) {
    this.currentService
      .usersUpdatePasswordByUserIdGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          const modalResult = this.dialogService.openModal({
            component: UpdatePasswordForm,
            data: userId,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe((res) => {
              if (res) {
                this.getTableData();
                this.cd.detectChanges();
              }
            });
        }
      });
  }

  openErrorDialog(
    title?: string,
    message?: string,
    status: DialogStatus = DialogStatus.error
  ) {
    this.dialogService.openDialog({
      title: title,
      message: message,
      status: status,
    });
  }

  InboxExcelReportApi() {
    this.excelFileService
      .excelCreateUsersExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}usersExcel`,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
          };

          const modalResult = this.dialogService.openModal({
            component: CreateUsersExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  resellerExcelReportApi() {
    let data = {
      title: 'common.downloadResellerExcel',
      comparisonObjects: this.comparisonObjects,
      sortObject: this.sortObject,
      resellerUserId: this.resellerUserId,
    };

    const modalResult = this.dialogService.openModal({
      component: CreateUsersExcelDialogComponent,
      data: data,
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe();
  }

  //#endregion

  //#region Import Numbers from xlsx
  onShowImportUsersFromXlsx() {
    try {
      this.pageConfig.loading = true;
      this.isShowUsersImportFromXlsx = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  getImportNumbersFromXlsxResponse() {
    try {
      this.getTableData();
      this.isShowUsersImportFromXlsx = !this.isShowUsersImportFromXlsx;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onShowUserOrganizationAuditPage() {
    this.userOrganizationAuditPage = true;
  }

  onHideUserOrganizationAuditPage() {
    this.showParent = true;
    this.getParentQueryString();
    this.userOrganizationAuditPage = false;
  }

  onShowUserAuthentication() {
    this.isShowUserAuthentication = true;
  }

  onShowDocumentations(userId: number, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Documents_key +
          '=' +
          userId
      );
    }
    this.isShowUserDocumentation = true;
    this.selectedUserId = userId;
  }

  onHideDocumentations() {
    this.showParent = true;
    this.getParentQueryString();
    this.isShowUserDocumentation = false;
  }

  onTransferPrivateNumber(userId: number, setUrl = true) {
    try {
      this.showParent = false;
      this.setParentQueryString();
      if (setUrl) {
        this.location.go(
          window.location.pathname +
            '?' +
            QueryStringTypesEnum.TransferPrivateNumber_key +
            '=' +
            userId
        );
      }
      this.isShowTransferPrivateNumber = true;
      this.transferPrivateNumberFormPageConfig.vocabs =
        'pages.assignNumbers.privateNumberSendLimit.' + 'form.';
      this.selectedUserId = userId;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  onShowIncreaseUserCredit(user: UserWithPaginationDto) {
    this.getOrganizationCreditApi(user);
  }

  //#region impersonate

  onUserImpersonate(userId) {
    this.accountImpersonateUserApi(userId);
  }

  //#endregion

  //#region Reseller
  onShowResellerOrganizations(userId: number, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Organization_key +
          '=' +
          userId
      );
    }
    this.selectedUserId = userId;
    this.isShowResellerOrganizations = true;
  }

  onHideResellerOrganizations() {
    this.showParent = true;
    this.getParentQueryString();
    this.isShowResellerOrganizations = false;
  }
  //#endregion

  onLockOut(userName: string) {
    const dialogResult = this.getConfirmDialog({
      content: userName,
      title: 'messages.unblockUserMessage',
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.pageConfig.loading = true;
          this.accountUnblockApi(userName);
        }
      });
  }

  getTransferPrivateNumberFormResponse(isSuccess) {
    this.showParent = true;
    this.getParentQueryString();
    if (isSuccess) this.getTableData();
    this.isShowTransferPrivateNumber = false;
  }

  onExcelReport() {
    this.InboxExcelReportApi();
  }

  onResellerExcelReport() {
    this.resellerExcelReportApi();
  }

  onShowTransactions(userName: string, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Transaction_key +
          '=' +
          userName
      );
    }
    this.selectedUserName = userName;
    this.isShowUserTransactions = true;
  }

  onHideTransactions() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowUserTransactions = false;
  }

  onShowPrivateNumbers(userId, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.PrivateNumbers_key +
          '=' +
          userId
      );
    }
    this.userId = userId;
    this.isShowUserPrivateNumbersLists = true;
  }

  onHidePrivateNumbers() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowUserPrivateNumbersLists = false;
  }

  onUpdate(id?, selectedOrganizationId?, setUrl = true) {
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          id
      );
    }
    this.formPageConfig.editData = {};
    this.formPageConfig.isEditMode = true;
    this.selectedOrganizationId = selectedOrganizationId;
    this.baseGetByIdApi(id);
  }

  onChangeReseller(resellerId) {
    this.resellerUserId = resellerId;
    this.getTableData();
  }
}
